var map = {
	"./citizenship.json": 63108,
	"./countries.json": 60240,
	"./farm/ownership_duration.json": 64305,
	"./farm/rating.json": 49042,
	"./farm/status.json": 14949,
	"./farm/type.json": 44415,
	"./investment.json": 26883,
	"./page/page.json": 22153,
	"./pagination.json": 93218,
	"./profile.json": 23203,
	"./reserved_urls.json": 49949,
	"./transfer.json": 50969,
	"./usaStates.json": 30967
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49144;